import React, { useState } from "react";
import { Button, Tag, Space, Table } from "antd"
import { CloseOutlined } from '@ant-design/icons';
import { Rnd } from "react-rnd";
import { useAtom } from "jotai";
import { isValidatedSpectraTableOpenState } from "../stateManagement/commonState";
import styles from './ValidatedSpectraTable.module.css';


const ValidatedSpectraTable = () => {

    const [isValidatedSpectraTableOpen, setIsValidatedSpectraTableOpen] = useAtom(isValidatedSpectraTableOpenState);
    const [modalWindowState, setModalWindowState] = useState({
        width: '500px',
        height: '500px',
        x: 10,
        y: 10,
    });

    const validatedSpectraTableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Tags',
            key: 'tags',
            dataIndex: 'tags',
            render: (_, { tags }) => (
                <>
                    {tags.map(tag => {
                        let color = tag.length > 5 ? 'geekblue' : 'green';
                        if (tag === 'loser') {
                            color = 'volcano';
                        }
                        return (
                            <Tag color={color} key={tag}>
                                {tag.toUpperCase()}
                            </Tag>
                        );
                    })}
                </>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <a>Invite {record.name}</a>
                    <a>Delete</a>
                </Space>
            ),
        },
    ];
    const [validatedSpectraTableData, setValidatedSpectraTableData] = useState([
        {
            key: '1',
            name: 'John Brown',
            age: 32,
            address: 'New York No. 1 Lake Park',
            tags: ['nice', 'developer'],
        },
        {
            key: '2',
            name: 'Jim Green',
            age: 42,
            address: 'London No. 1 Lake Park',
            tags: ['loser'],
        },
        {
            key: '3',
            name: 'Joe Black',
            age: 32,
            address: 'Sydney No. 1 Lake Park',
            tags: ['cool', 'teacher'],
        },
    ]);

    return (
        <>
            {isValidatedSpectraTableOpen && (
                <div style={{
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    zIndex: 100,
                    pointerEvents: 'none'
                }}
                >
                    <Rnd
                        dragHandleClassName="drag-handle"
                        style={{
                            pointerEvents: 'auto',
                            borderRadius: '16px',
                            position: 'relative',
                            boxShadow: '3px 3px 10px 3px #dddddd',
                        }}
                        size={{ width: modalWindowState.width, height: modalWindowState.height }}
                        position={{ x: modalWindowState.x, y: modalWindowState.y }}
                        onDragStop={(e, d) => {
                            setModalWindowState(prev => ({ ...prev, x: d.x, y: d.y }))
                        }}
                        onResize={(e, direction, ref, delta, position) => {
                            setModalWindowState(prev => ({
                                ...prev,
                                width: ref.style.width,
                                height: ref.style.height,
                                ...position
                            }));
                        }}
                        minWidth={450}
                        minHeight={450}
                        maxWidth={900}
                        maxHeight={900}
                    >
                        <div className="drag-handle" style={{
                            zIndex: '102',
                            position: 'absolute',
                            width: '100%',
                            height: '32px',
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            borderRadius: '16px 16px 0 0',
                        }}>
                            <p style={{ textAlign: 'center', lineHeight: '32px', margin: '0', cursor: 'default' }}>Validated Spectra</p>
                        </div>
                        <div
                            style={{
                                backgroundColor: '#f5f5f5',
                                position: 'relative',
                                top: '0px',
                                left: '0px',
                                width: `calc(${modalWindowState.width})`,
                                height: `calc(${modalWindowState.height})`,
                                zIndex: 101,
                                borderRadius: '16px',
                                padding: '16px'
                            }}>
                            <div
                                style={{
                                    width: '100%',
                                    height: `calc(${modalWindowState.height} - 40px)`,
                                    marginTop: 'calc(24px + 32px)',
                                    overflow: 'hidden',
                                }}
                                className={styles.popup}
                            >
                                <Table columns={validatedSpectraTableColumns} dataSource={validatedSpectraTableData} />
                            </div>
                        </div>
                        <Button
                            type="primary"
                            danger
                            shape="circle"
                            size="small"
                            icon={<CloseOutlined style={{ fontSize: '9px' }} />}
                            onClick={() => {
                                setIsValidatedSpectraTableOpen(false);
                            }}
                            style={{
                                position: 'fixed',
                                top: '8px',
                                left: '16px',
                                minWidth: '16px',
                                width: '16px',
                                height: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 103,
                            }}
                        />
                    </Rnd>
                </div>
            )}
        </>
    )
}

export default ValidatedSpectraTable;